<script>
import moment from 'moment'

export default {
  name: 'Post',
  props: {
    postId: { type: Number, required: true },
  },
  computed: {
    post() { return this.$store.state.post.map[this.postId] },
    displayName() { return this.$store.getters['user/displayName'] },
    initials() { return this.$store.getters['user/initials'] },
    postMoment() { return moment(this.post.created) },
    lastHourPost() {
      return moment(this.post.created).isAfter(moment().subtract(1, 'h'))
    },
  },
}
</script>

<template>
  <VCard class="Post">
    <VListItem>
      <AppLink
        :to="{ name: 'user', params: { userId: post.authorId } }"
        class="white--text font-weight-bold"
      >
        <VListItemAvatar color="primary">
          {{ initials(post.authorId) }}
        </VListItemAvatar>
      </AppLink>
      <VListItemContent>
        <VListItemTitle>
          <AppLink
            :to="{ name: 'user', params: { userId: post.authorId } }"
            class="primary--text pr-2 font-weight-bold"
          >
            {{ displayName(post.authorId) }}
          </AppLink>
          <b class="grey--text mr-1">&gt;</b>
          <i
            v-if="post.allUsers"
            class="grey--text"
          >
            Всем сотрудникам
          </i>
          <template v-else-if="post.fixedReaders">
            <i
              v-for="(userId, i) in post.fixedReaders"
              :key="userId"
              class="grey--text"
            >
              {{ displayName(userId) }}<template
                v-if="i < (post.fixedReaders.length - 1)"
              >,</template>
            </i>
            <i
              v-if="post.fixedReaders.length === 0"
              class="grey--text"
            >
              Самому себе
            </i>
          </template>
          <template v-else>
            <i
              v-if="post.targetsId"
              class="grey--text"
            >
              Руководителям<template
                v-if="post.extraReaders && post.extraReaders.length"
              >,</template>
            </i>
            <i
              v-for="(userId, i) in post.extraReaders"
              :key="userId"
              class="grey--text"
            >
              {{ displayName(userId) }}<template
                v-if="i < (post.extraReaders.length - 1)"
              >,</template>
            </i>
          </template>
        </VListItemTitle>
        <VListItemSubtitle :title="postMoment.format('lll')">
          {{ lastHourPost ? postMoment.fromNow() : postMoment.calendar() }}
        </VListItemSubtitle>
      </VListItemContent>
    </VListItem>
    <VCardTitle>{{ post.title }}</VCardTitle>
    <!-- eslint-disable vue/no-v-html -->
    <VCardText
      class="post-body"
      v-html="post.body"
    />
    <!-- eslint-enable vue/no-v-html -->
  </VCard>
</template>

<style lang="sass" scoped>
  .post-body ::v-deep img
    max-width: 100% !important
</style>
